/**
 * @generated SignedSource<<a821cfb365580b0b1c05286d1bcd98c6>>
 * @relayHash 7755c377f2c69be889ce4d8170ec4ba9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b536d088c89810dc6d549e9b590c9cde2aafb29de8e450b345615917df47a9a9

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_jiraBusinessBoardEmbedQuery } from './src_jiraBusinessBoardEmbedQuery.graphql';

import isUsingNewCreate_provider from '@atlassian/jira-relay-provider/src/mbw-67-board-issue-create.relayprovider';
import withMergedWorkflows_provider from '@atlassian/jira-relay-provider/src/merge-board-workflows.relayprovider';
import isBusinessRelayBoardWorkflowEditingEnabled_provider from '@atlassian/jira-relay-provider/src/relay-board-workflow-editing.relayprovider';

const node: PreloadableConcreteRequest<src_jiraBusinessBoardEmbedQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "b536d088c89810dc6d549e9b590c9cde2aafb29de8e450b345615917df47a9a9",
    "metadata": {},
    "name": "src_jiraBusinessBoardEmbedQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcmbw67boardissuecreaterelayprovider": isUsingNewCreate_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcrelayboardworkfloweditingrelayprovider": isBusinessRelayBoardWorkflowEditingEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcmergeboardworkflowsrelayprovider": withMergedWorkflows_provider
    }
  }
};

export default node;
